import { atom } from "jotai";
import type { YouTubePlayer } from "youtube-player/dist/types";

type OnlyOnePlayingPlayer = {
  adsManager?: google.ima.AdsManager;
  currentYoutubeVideoId?: string;
  stopYoutubeAutoplay: boolean;
  textToSpeechPlayer?: HTMLVideoElement;
  youtubePlayer?: YouTubePlayer;
};

export const onlyOnePlayingPlayerAtom = atom<OnlyOnePlayingPlayer>({
  adsManager: undefined,
  currentYoutubeVideoId: undefined,
  stopYoutubeAutoplay: false,
  textToSpeechPlayer: undefined,
  youtubePlayer: undefined,
});
